import React from 'react';
import {
    LayoutDashboard, Users, Percent, CreditCard,
    Settings, LogOut, Shield, ArrowLeft, Bot, Zap, Receipt, Wallet, Smartphone, UserCheck
} from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logoPro from '../logo_pro.png';

export const AdminSidebar: React.FC = () => {
    const location = useLocation();
    const { logout } = useAuth();

    const isActive = (path: string) => location.pathname === path ? 'active' : '';

    return (
        <div className="sidebar pro-sidebar admin-sidebar border-r border-orange-500/10 bg-[#050505]">
            <div className="brand-logo" style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                <img src={logoPro} alt="Hotlize Logo" style={{ maxWidth: '100%', height: 'auto' }} />
                <div className="flex items-center gap-1 mt-2">
                    <Shield size={12} className="text-orange-500" />
                    <span className="text-[10px] font-mono text-orange-500/50 uppercase tracking-tighter">Master Control</span>
                </div>
            </div>

            <nav className="sidebar-nav">
                <Link to="/banana" className={`nav-item ${isActive('/banana')}`}>
                    <LayoutDashboard size={20} />
                    <span>Visão Geral</span>
                </Link>

                <div className="nav-group-divider"></div>

                <Link to="/banana/usuarios" className={`nav-item ${isActive('/banana/usuarios')}`}>
                    <Users size={20} />
                    <span>Gestão de Clientes</span>
                </Link>

                <Link to="/banana/usuarios-ativos" className={`nav-item ${isActive('/banana/usuarios-ativos')}`}>
                    <UserCheck size={20} />
                    <span>Usuários Ativos</span>
                </Link>

                <Link to="/banana/bots" className={`nav-item ${isActive('/banana/bots')}`}>
                    <Bot size={20} />
                    <span>Gestão de Bots</span>
                </Link>

                <Link to="/banana/assinaturas" className={`nav-item ${isActive('/banana/assinaturas')}`}>
                    <CreditCard size={20} />
                    <span>Gestão de Assinaturas</span>
                </Link>

                <Link to="/banana/taxas" className={`nav-item ${isActive('/banana/taxas')}`}>
                    <Percent size={20} />
                    <span>Configurar Taxas</span>
                </Link>

                <Link to="/banana/transacoes" className={`nav-item ${isActive('/banana/transacoes')}`}>
                    <Receipt size={20} />
                    <span>Transações</span>
                </Link>

                <Link to="/banana/saques" className={`nav-item ${isActive('/banana/saques')}`}>
                    <CreditCard size={20} />
                    <span>Saques Pendentes</span>
                </Link>

                <Link to="/banana/saldo-saque" className={`nav-item ${isActive('/banana/saldo-saque')}`}>
                    <Wallet size={20} />
                    <span>Saldo para Saque</span>
                </Link>

                <Link to="/banana/adquirentes" className={`nav-item ${isActive('/banana/adquirentes')}`}>
                    <Zap size={20} />
                    <span>Adquirentes</span>
                </Link>

                <div className="nav-group-divider"></div>

                <Link to="/banana/telegram-apps" className={`nav-item ${isActive('/banana/telegram-apps')}`}>
                    <Smartphone size={20} />
                    <span>Apps Telegram</span>
                </Link>

                <Link to="/banana/configuracoes" className={`nav-item ${isActive('/banana/configuracoes')}`}>
                    <Settings size={20} />
                    <span>Configurações</span>
                </Link>
            </nav>

            <div className="sidebar-footer">
                <Link to="/" className="nav-item mb-4 text-gray-500 hover:text-white transition-colors">
                    <ArrowLeft size={18} />
                    <span className="text-xs">Voltar ao App</span>
                </Link>

                <div className="user-profile border-t border-white/5 pt-4">
                    <div className="user-avatar bg-orange-600">M</div>
                    <div className="user-details">
                        <span className="text-white">Master Admin</span>
                        <small className="text-orange-500/70 font-mono">ROOT ACCESS</small>
                    </div>
                    <button
                        onClick={logout}
                        className="ml-auto text-gray-500 hover:text-red-500 transition-colors"
                        title="Sair"
                    >
                        <LogOut size={18} />
                    </button>
                </div>
            </div>
        </div>
    );
};
